// import { createDfpAdComponent } from "./dfp-ad-impl";
import { createDfpAdComponent, refreshDfpAds } from "@quintype/components";
import get from "lodash/get";
import PT from "prop-types";
import React, { useEffect } from "react";

const ViewPortSizeMappingBanner970x90 = [
  { viewport: [1024, 768], sizes: [[970, 90]] },
  { viewport: [640, 480], sizes: [[728, 90]] },
  { viewport: [0, 0], sizes: [[300, 250]] }
];

export const CONFIG = {
  xxxx: {
    adUnit: "xxxx",
    sizes: [[970, 90], [728, 90], [300, 250]],
    viewPortSizeMapping: ViewPortSizeMappingBanner970x90
  }
};

const getStoryType = state => {
  const pagetype = get(state, ["qt", "pageType"], "");

  if (pagetype === "story-page") {
    return get(state, ["qt", "data", "story", ["story-template"]]) || "text-story";
  } else {
    return "NA";
  }
};

const getStorySectionName = state => {
  const pagetype = get(state, ["qt", "pageType"], "");
  if (pagetype === "story-page") {
    return get(state, ["qt", "data", "story", "sections", 0, "slug"]);
  } else if (pagetype === "section-page") {
    return get(state, ["qt", "title"]);
  }
  return "NA";
};

const getCollectionSlug = (state, props) => {
  const pagetype = get(state, ["qt", "pageType"], "");
  if (pagetype === "story-page") {
    return get(state, ["qt", "data", "story", "sections", 0, "slug"], "");
  }
  return get(props, ["collectionSlug"], "NA");
};

const getOrderId = (state, props) => {
  const pagetype = get(state, ["qt", "pageType"], "");
  if (pagetype === "story-page") {
    return get(props, ["id"]) || "NA";
  }
  return "NA";
};

const getStoryId = state => {
  const pagetype = get(state, ["qt", "pageType"], "");
  if (pagetype === "story-page") {
    return get(state, ["qt", "data", "story", "id"]) || "NA";
  }
  return "NA";
};

const DfpAdContent = props => {
  const { slotId } = props;
  return createDfpAdComponent({
    defaultNetworkID: "3849069",
    config: CONFIG,
    slotId,
    targeting: function(state, ownProps) {
      const params = {
        publisherid: get(state, ["qt", "config", "publisher-id"], 51),
        publisherName: get(state, ["qt", "config", "publisher-name"], "december"),
        pageType: get(state, ["qt", "pageType"]) || "NA",
        Environment: get(state, ["qt", "config", "publisher-attributes", "env"], ""),
        storyType: getStoryType(state),
        collectionSlug: getCollectionSlug(state, ownProps),
        sectionSlug: getStorySectionName(state),
        storyId: getStoryId(state),
        orderId: getOrderId(state, ownProps)
      };
      return params;
    }
  });
};

const DfpAd = props => {
  useEffect(() => {
    if (props.shouldRefreshOnce && props.slotId) {
      setTimeout(() => {
        refreshDfpAds(props.slotId);
      }, 500);
    }
  }, [props.slotId]);
  const AdComponent = DfpAdContent({ ...props, adtype: CONFIG[props.adtype] ? props.adtype : "xxxx" });
  return (
    <div>
      <AdComponent {...props} />
    </div>
  );
};
DfpAd.propTypes = {
  adtype: PT.string,
  shouldRefreshOnce: PT.bool,
  slotId: PT.string
};

export default DfpAd;
